export const mockData = {
  director: {
    name: "Rrammy",
    tagline: "Cinematic Storyteller",
    bio: "A visionary filmmaker known for powerful cinematic storytelling across advertising and narrative films. With over 500 television and digital commercials and multiple award-winning short films, Rrammy crafts stories that resonate with audiences worldwide.",
    experience: "500+ Commercials Directed",
    profileImage: "https://customer-assets.emergentagent.com/job_rrammy-films/artifacts/m1x8sevv_IMG_1731_2.jpg",
    colorImage: "https://customer-assets.emergentagent.com/job_rrammy-films/artifacts/ny1npo4q_ChatGPT%20Image%20Mar%2016%2C%202026%20at%2002_36_39%20PM.png",
    email: "me@rrammy.com",
    emailSecondary: "rammyfilms@gmail.com",
    facebook: "https://facebook.com/nomadrammy"
  },
  
  featuredFilms: [
    {
      id: 1,
      title: "Six",
      platform: "Jio Hotstar",
      description: "A gripping narrative that showcases the power of visual storytelling in the digital age.",
      videoUrl: "https://www.youtube.com/watch?v=BuWVoH2xGjY",
      embedUrl: "https://www.youtube.com/embed/BuWVoH2xGjY",
      thumbnail: "https://img.youtube.com/vi/BuWVoH2xGjY/maxresdefault.jpg",
      category: "Digital Content",
      awards: "Featured on Jio Hotstar"
    },
    {
      id: 2,
      title: "Una",
      platform: "Award-Winning Short Film",
      description: "An emotionally powerful short film that explores the depths of human connection and storytelling.",
      videoUrl: "https://www.youtube.com/watch?v=rYEVlL0cwtc",
      embedUrl: "https://www.youtube.com/embed/rYEVlL0cwtc",
      thumbnail: "https://img.youtube.com/vi/rYEVlL0cwtc/maxresdefault.jpg",
      category: "Short Film",
      awards: "Award-Winning Film"
    },
    {
      id: 3,
      title: "Rinti",
      platform: "Award-Winning Short Film",
      description: "A cinematic masterpiece that captures the essence of storytelling through compelling visuals.",
      videoUrl: "https://www.youtube.com/watch?v=7uWui8UA6nA",
      embedUrl: "https://www.youtube.com/embed/7uWui8UA6nA",
      thumbnail: "https://img.youtube.com/vi/7uWui8UA6nA/maxresdefault.jpg",
      category: "Short Film",
      awards: "Award-Winning Film"
    },
    {
      id: 4,
      title: "The Unknown Codes",
      platform: "Award-Winning Short Film",
      description: "A thought-provoking narrative that pushes the boundaries of conventional filmmaking.",
      videoUrl: "https://www.youtube.com/watch?v=hWMKmRzR33Q",
      embedUrl: "https://www.youtube.com/embed/hWMKmRzR33Q",
      thumbnail: "https://img.youtube.com/vi/hWMKmRzR33Q/maxresdefault.jpg",
      category: "Short Film",
      awards: "Award-Winning Film"
    }
  ],
  
  showreelVideos: [
    "https://www.youtube.com/embed/BuWVoH2xGjY",
    "https://www.youtube.com/embed/rYEVlL0cwtc",
    "https://www.youtube.com/embed/7uWui8UA6nA",
    "https://www.youtube.com/embed/hWMKmRzR33Q"
  ],
  
  categories: [
    {
      name: "Short Films",
      description: "Award-winning narrative films",
      count: 4
    },
    {
      name: "Commercial Films",
      description: "500+ television and digital commercials",
      count: 500
    },
    {
      name: "Digital Campaigns",
      description: "Innovative digital storytelling",
      count: 50
    },
    {
      name: "Branded Content",
      description: "Premium brand narratives",
      count: 100
    }
  ],
  
  mediaInteractions: [
    {
      id: 1,
      title: "Jagran Film Festival",
      description: "Panel discussion on the future of independent cinema",
      year: "2024"
    },
    {
      id: 2,
      title: "IIT Bombay",
      description: "Guest lecture on cinematic storytelling and visual narrative",
      year: "2024"
    }
  ],
  
  testimonials: [
    {
      text: "Rrammy brings a unique cinematic vision to every project. His ability to tell compelling stories is unmatched.",
      author: "Industry Professional"
    },
    {
      text: "Working with Rrammy elevated our brand story to cinematic heights. A true storyteller.",
      author: "Brand Director"
    }
  ]
};